import { BThead } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBThead = createEgBootstrapProxy("EgBThead", BThead);
